"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundException = void 0;
const domain_exception_1 = require("./domain.exception");
/**
 * Should be thrown when attempting to retrieve some kind of object from any kind of source but it cannot be found. This
 * exception can be thrown either as a result of a fault from the client or by the server.
 *
 * For example:
 * - Attempting to find a customer by ID provided by the client but it does not exist (client error)
 * - Attempting to find some internal value from the database but it could not be found (server error)
 */
class NotFoundException extends domain_exception_1.DomainException {
}
exports.NotFoundException = NotFoundException;
